export const ADDRESS_POPUP_FORMS = {
  login: 'login',
  logout: 'logout',
  requestPassword: 'requestPassword',
  selectAddress: 'selectAddress',
  changePassword: 'changePassword',
  deleteiConfirmaion: 'deleteiConfirmaion'
};
